define('MM/Models/ContentSearch/FacetToggleViewModel',["jquery", "knockout", "score_bootstrap/Models/SitecoreId"], function ($, ko, SitecoreId) {
    "use strict";

    function FacetToggleViewModel($dataEl, koCheckedValue) {
        var defaultId = SitecoreId.parse($dataEl.data("defaultId")),
            defaultValue = $dataEl.data("defaultValue"),
            defaultText = $dataEl.data("defaultText"),
            checkedId = SitecoreId.parse($dataEl.data("checkedId")),
            checkedValue = $dataEl.data("checkedValue"),
            checkedText = $dataEl.data("checkedText");

        this.checked = koCheckedValue;

        this.count = ko.observable(0);

        this.resetCount = function () {
            this.count(0);
        };

        this.getFacets = function () {
            return [{ id: checkedId, value: checkedValue, text: checkedText, selected: (function () { return this.checked() }).bind(this), count: ko.observable(0) },
            { id: defaultId, value: defaultValue, text: defaultText, selected: (function () { return !this.checked() }).bind(this), count: ko.observable(0) }];
        };

        this.getSelectedFacetForAsString = ko.computed(function () {
            return this.checked() === false
                ? null
                : { id: checkedId, value: checkedValue, text: checkedText, selected: (function () { return this.checked() }).bind(this) };
        }, this);

        ko.applyBindings(this, $dataEl.get(0));
    }

    return FacetToggleViewModel;
});
